export const routeRolesPermissions = (user: any, _pRoutes: any) => {
    if(user?.isUser && !user?.accessRight?.hasAdminAccess ) {
        for (const route of _pRoutes) {
            for (const child of route.children ?? []) {//console.log('route>>', route)
                if(child.path === "/dashboard" || child.path === "/sites" || child.path === "/scan" || child.path === "/scan-history") {
                    if(!user?.accessRight?.assignRights.dashboard.read){
                        route.children = route.children.filter((child: any) => child.path !== "/dashboard");
                    }
                    if(!user?.accessRight?.assignRights.sites.read){
                        route.children = route.children.filter((child: any) => child.path !== "/sites");
                    }
                    if(!user?.accessRight?.assignRights.scan.edit){
                        route.children = route.children.filter((child: any) => child.path !== "/scan");
                    }
                    if(!user?.accessRight?.assignRights.sitesHistory.read){
                        route.children = route.children.filter((child: any) => child.path !== "/scan-history");
                    }

                    route.children = route.children.filter((child: any) => child.path !== "/users");
                    route.children = route.children.filter((child: any) => child.path !== "/roles-permission");
                }   
            }
            break;
        }
    }

    // User will not see subscription, Payment and API Integration routes
    if(user?.isUser) {
        for (const route of _pRoutes) {
            for (const child of route.children ?? []) {
                if(child.path === "/subscription" || child.path === "/payment" ) {
                    route.children = route.children.filter((child: any) => child.path !== "/subscription");
                    route.children = route.children.filter((child: any) => child.path !== "/payment");
                }
            }
            break;
        }
        
    }

    return _pRoutes;
}